export default {
  "b2b.zdroje-grid-columns.typ.name.label": "Název",
  "b2b.zdroje-grid-columns.typ.vyznam.label": "Význam",
  "b2b.zdroje-grid-columns.typ.popis.label": "Popis"
};
